import styleInject from '../../node_modules/.pnpm/style-inject@0.3.0/node_modules/style-inject/dist/style-inject.es.js';

var css_248z = "/*\n *\n * Copyright (c) Vaisala Oyj. All rights reserved.\n *\n */\n/*\n *\n * Copyright (c) Vaisala Oyj. All rights reserved.\n * \n */\n.vai-body-text {\n  display: block;\n  font-size: 14px;\n  line-height: 16px;\n  color: #003462;\n  margin: 0 0 16px 0;\n}\n.vai-theme-dark .vai-body-text {\n  color: #b5b5b5;\n}";
styleInject(css_248z);

export { css_248z as default };
